import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-brand-sage/20 bg-brand-warm text-center text-brand-text-muted text-sm font-medium" data-id="element-125">
      <div className="max-w-xl mx-auto space-y-4" data-id="element-126">
        <p className="text-brand-olive font-bold uppercase tracking-wider" data-id="element-127">
          🍃 METODO MEDITERRANEO™
        </p>
        <p className="leading-relaxed" data-id="element-128">
          Il sistema alimentare che si adatta alla tua vita — non il contrario.
          Ispirato alla tradizione mediterranea. Costruito per la vita moderna.
        </p>
        <p className="text-xs text-gray-500 mt-8" data-id="element-129">
          © METODO MEDITERRANEO™ 2026 — Tutti i diritti riservati. Questo
          prodotto è un sistema di educazione alimentare a scopo informativo.
          Non sostituisce il parere di un medico o di un nutrizionista.
        </p>
      </div>
    </footer>;
}